import { lazy, Suspense } from "react";
import { LegacyLayout } from "../bridges/legacyLayout";
import { ToastProvider } from "../ui";
import { BlockedToastHost } from "../access/components/BlockedToastHost";
import { ReportDraftResender } from "../visits/components/ReportDraftResender";
import { useFrameMode } from "./frameMode";
import { NextFrame } from "./NextFrame";

/** The routes data layer is big and most visits never open Routes: the live listener loads on its own, after the first paint (5B final review I3). */
const RoutesLiveHost = lazy(() => import("./RoutesLiveHost").then((m) => ({ default: m.RoutesLiveHost })));

/** Layout route element: today's frame or the new one. The new frame does not wait for Google Maps (4.29).
 *  In both frames, route live events (5B) toast, and report drafts that failed for want of a connection are sent again once it is back (2D F5).
 *  ONE toast provider wraps the hosts AND the frame, so a toast made by a page that is then left (Undo after "Delete route") survives the jump
 *  in today's frame too (5B final review I1). */
export const FrameSwitch = ({ mapsReady, bootLoader }: { mapsReady: boolean; bootLoader: JSX.Element }) => (
  <ToastProvider>
    <ReportDraftResender /><BlockedToastHost /><Suspense fallback={null}><RoutesLiveHost /></Suspense>
    {useFrameMode() === "next" ? <NextFrame mapsReady={mapsReady} /> : mapsReady ? <LegacyLayout /> : bootLoader}
  </ToastProvider>
);
